import ZTooltip from './ZTooltip.vue'

export default ZTooltip
